<script>
import formatServiceTime from "@utils/format-service-time";
import formatCurrency from "@utils/format-currency";
import formatPrice from "@utils/format-price";
import { authComputed, merchantComputed } from '@store/helpers'
import { memberLevelPriceDiscount } from "@utils/ipetbooking-level";

  export default {
    components: {
      CarouselImage: () => import("./CarouselImage.Jtails"),
    },
    props: {
      reservationItem: {
        type: Object,
        default: () => {
          return {
            store: {
              title: '台北店',
              alias: 'taipei',
              storeType: 'store'
            },
            title: 'A. 小美容',
            "sizeTitle": "小型 (3-5kg)",
            "categoryTitle": "狗狗",
            "serviceTime": 120,
            "basePrice": 700,
            "price": 700,
          }
        }
      }
    },
    computed: {
    ...authComputed,
    ...merchantComputed,
  },
    methods: {
      formatServiceTime,
      formatCurrency,
      formatPrice,
      memberLevelPriceDiscount
    }
  }
</script>
<template>
  <section :class="[$style.itemSectionInfoJtails, { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]">
    <CarouselImage
      v-if="!!reservationItem.images[0] && $globalIsDingBeauty"
      :carousel-list="reservationItem.images"
      class="itemSectionInfoJtails__image"
    />
    <template v-if="$globalIsDingBeauty">
      <div class="itemSectionInfoJtails__title">
        {{ reservationItem.title }}
      </div>
      <div class="itemSectionInfoJtails__meta">
        <div class="itemSectionInfoJtails__metaItem">
          <span class="fs-2sm text-gray-2">分店</span>
          <div>{{ reservationItem.store.title }}</div>
        </div>
        <div class="itemSectionInfoJtails__metaItem ml-2">
          <span class="fs-2sm text-gray-2">服務時長</span>
          <div>{{ formatServiceTime(reservationItem.serviceTime) }}</div>
        </div>
      </div>
    </template>
    <template v-else>
      <BaseStoreTagList
        :store-list="[reservationItem.store]"
      />
      <div class="itemSectionInfoJtails__title">
        {{ reservationItem.title }}
      </div>
      <div class="itemSectionInfoJtails__meta">
        <i class="fontello fontello-paw text-primary mr-2"></i>{{ reservationItem.categoryTitle }} |
        {{ reservationItem.sizeTitle }}<span
        class="text-gray-3 mx-2">•</span><i
        class="fontello fontello-time text-primary  mr-2"></i>{{ formatServiceTime(reservationItem.serviceTime) }}
      </div>
      <div>
        <span
          v-if="reservationItem.levelDiscount > 0"
          class="itemSectionInfoJtails__basePrice"
        >售價NT$ {{ formatCurrency(reservationItem.price) }}</span>
        <span
          v-if="reservationItem.price < reservationItem.basePrice  && !reservationItem.levelDiscount > 0"
          class="itemSectionInfoJtails__basePrice"
        >原價NT$ {{ formatCurrency(reservationItem.basePrice) }}</span>
        <span class="itemSectionInfoJtails__price">
          
          {{ reservationItem.levelDiscount > 0 ? `會員價 ${formatPrice(memberLevelPriceDiscount(reservationItem.price, reservationItem))}` : formatPrice(reservationItem.price)}}
          <span v-if="!!reservationItem.priceIsFlexible" class="fs-sm">起</span>
        </span>
      </div>
    </template>
  </section>
</template>
<style lang="scss" module>
  .itemSectionInfoJtails {
    position: relative;
    padding: 2rem;
    margin-top: 3rem;
    border: 1px solid #90B9AB;

    &::before {
      position: absolute;
      top: 0.5rem;
      right: 0.5rem;
      bottom: 0.5rem;
      left: 0.5rem;
      z-index: -1;
      content: '';
      background: rgba($color-primary, 0.1);
    }
    :global {
      .itemSectionInfoJtails {
        &__title {
          @extend %FontSerifWeightJtails;

          margin-bottom: 1.25rem;
          font-size: 1.25rem;
        }

        &__meta {
          margin-bottom: 0.5rem;
          font-size: 0.875rem;
        }

        &__price {
          font-family: $font-number;
        }

        &__basePrice {
          margin-right: 0.5rem;
          font-family: $font-number;
          font-size: 0.875rem;
          color: $color-gray-2;
          text-decoration: line-through;
        }
      }
    }
    &.isStyleDingBeauty {
      border: none;
      padding: 0;
      &::before{
        content: none;
      }
      :global {
        .itemSectionInfoJtails {
          &__image {
            margin-bottom: 2rem;
          }
          &__title {
            margin-bottom: 1.25rem;
            font-size: 1.5rem;
            color: $color-secondary;
            font-weight: 500;
            font-family: unset;
          }

          &__meta {
            &Item {
              border: 1px solid $color-line-3;
              padding: 1rem 1.5rem 1rem 1rem;
              display: inline-block;
            }
          }

          &__price {
            font-family: $font-number;
          }

          &__basePrice {
            margin-right: 0.5rem;
            font-family: $font-number;
            font-size: 0.875rem;
            color: $color-gray-2;
            text-decoration: line-through;
          }
        }
      }
    }
  }
</style>
